import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar/NavBar";
import { Banner } from "./components/Banner";
import { Footer } from "./components/Footer";
import Projects from "./components/Projects/Projects";
import Experience from "./components/experience/experience";
import Blogs from "./components/Blogs/Blogs";
import About from "./components/About/About";
import RotatingSkills from "./components/RotatingSkills/RotatingSkills";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <About />
      <RotatingSkills />
      <Experience />
      <Projects />
      <Blogs />
      <Footer />
    </div>
  );
}

export default App;
